(function (Nav, $, undefined) {

  var $body = $('body'),
      $header = $('#header'),
      $flyout = $('.js-touch-flyout'),
      $icon = $('.js-right-icon'),
      $slideMenu = $('.js-expand'),
      flyoutActive = false;

  var showFlyout = function(){
    Scroll.lock();
    Overlay.show();
    $body.addClass('flyout-active');
    $flyout.addClass('is-active');
    flyoutActive = true;
  };

  var hideFlyout = function(){
    Scroll.unlock();
    Overlay.hide();
    $body.removeClass('flyout-active');
    $flyout.removeClass('is-active');
    flyoutActive = false;
  };

  var toggleFlyout = function(){
    if(flyoutActive) {
      hideFlyout();
    } else {
      showFlyout();
    }
    return;
  };

  var copyLinks = function(){
    for(var i = 0; i < $icon.length; i++) {
      var $curr = $icon.eq(i);
      $curr.clone('false').appendTo('.right-nav',$header);
    }
  };

  var bindUIActions = function(){
    $header.on('click', '#mobile-nav-toggle', function (e) {
      e.stopPropagation();
      toggleFlyout();
    });

    $header.on('click', '.close-mobile-nav-flyout', function () {
      toggleFlyout();
      return false;
    });

    $header.on('click',function(){
      hideFlyout();
    });

    $header.on('click','>.mobile, .js-touch-flyout',function(e){
      e.stopPropagation();
    });

    $('.nav-item').on('mouseenter',function(){
      $(this).addClass('is-active');
    }).on('mouseleave',function(e){
      $(this).removeClass('is-active');
    });

    $slideMenu.on('click', function (e) {
      var $this = $(this),
          $scope = $this.next(),
          classes = $this.attr('class').split(' '),
          selector = '';

      for (var i = 0; i < classes.length; i++) {
        selector = selector + '.' + classes[i];
      }

      if (IsMobile.check()) {
        $scope.slideToggle(300, function () {
          $scope.toggleClass('is-active');
        });
        $this.toggleClass('is-active');
        return false;
      }
    });
  };

  Nav.init = function(){
    copyLinks();
    bindUIActions();
  };

}(window.Nav = window.Nav || {}, jQuery));
